export class ObjectUtil {
  public static deepFreeze(obj: any) {
    Object.keys(obj).forEach((prop) => {
      if (typeof obj[prop] === 'object') this.deepFreeze(obj[prop]);
    });
    return Object.freeze(obj);
  }
}
